import React from 'react';

const CustomBotAvatar = () => {
    return (
        <div
            style={{
                display: 'none',
                //backgroundColor: '#00A887',
                //color: 'white',
                //borderRadius: '50%',
                //width: '40px',
                //height: '40px',
                //display: 'flex',
                //alignItems: 'center',
                //justifyContent: 'center',
                //fontWeight: 'bold'
            }}
            >
            D
        </div>
    );
};

export default CustomBotAvatar;